<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
        </div>

        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "SCHEDULE_DETAILS" | translate | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                <div class="col-12">
                    <div class="row">
                        <div class="card" style="margin: auto;width: 80%;">
                            <div class="card-body">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>{{ "COURSES" | translate | titlecase }}</th>
                                            <th>{{ "THEORY_HOURS" | translate | titlecase }}.</th>
                                            <th>{{ "CLINICAL_HOURS" | translate | titlecase }}.</th>
                                            <th>{{ "ASS_THEORY_HOURS" | translate | titlecase }}.</th>
                                            <th>{{ "ASS_PRACTICAL_HOURS" | translate | titlecase }}.</th>
                                            <th>{{ "ACTUAL_THEORY_HOURS" | translate | titlecase }}.</th>
                                            <th>{{ "ACTUAL_PRACTICAL_HOURS" | translate | titlecase }}.</th>
                                        </tr>
                                    </thead>
                                    
                                    <tbody>
                                        <tr *ngFor="let res of subjectAssignHours let i = index">
                                            <td>{{(globals.lang == 'ar')? res?.subjectNameAr : res?.subjectNameEn}}</td>
                                            <td>{{res?.theoHours}}</td>
                                            <td>{{res?.practicalHours}}</td>
                                            <td>{{res?.assignedTheoHours}}</td>
                                            <td>{{res?.assignedPracticalHours}}</td>
                                            <td>{{res?.actualTheoHours}}</td>
                                            <td>{{res?.actualPracticalHours}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <div class="row" style="display: flex; justify-content: center">
                                    <!-- <button type="button" class="btn btn-success" (click)="saveScheduleParts()"><i class="far fa-save"></i> {{
                                        "SAVE" | translate | titlecase }}</button> -->
                                    <span style="width: 50px;"></span>
                                    <a type="button" class="btn btn-success"
                                        routerLink="/schedule/schedule-details-preview"
                                        [queryParams]="{scheduleId: scheduleId, yearid: yearid, semesterid: semesterid, gradeid: gradeid}"><i
                                            class="fas fa-search"></i>{{
                                        "PREVIEW" | translate | titlecase }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="display: flex; justify-content: center">
                        <div class="col-md-3 form-group px-md-5 mb-4">
                            <label class="font-bold">{{"DAY" | translate | titlecase }}</label>
                            <select class="form-control custom-select" style="width: 250px;" [(ngModel)]="sectionDay">
                                <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}
                                </option>
                                <option *ngFor="let field of weekDays" value="{{field.dydate}}">
                                    {{field.dy}}</option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group px-md-5 mb-4">
                            <label class="font-bold">{{"TYPE" | translate | titlecase }}</label>
                            <select class="form-control custom-select" style="width: 250px;" [(ngModel)]="sectionType">
                                <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}
                                </option>
                                <option value="LECTURE">{{"LECTURE" | translate | titlecase }}</option>
                                <option value="BREAK">{{"BREAK" | translate | titlecase }}</option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group px-md-5 mb-4">
                            <label class="font-bold">{{"FROM" | translate | titlecase }}</label>
                            <input type="time" class="form-control" [(ngModel)]="timeFrom">
                        </div>
                        <div class="col-md-3 form-group px-md-5 mb-4">
                            <label class="font-bold">{{"TO" | translate | titlecase }}</label>
                            <input type="time" class="form-control" [(ngModel)]="timeTo">
                        </div>
                        <div class="col-md-3 form-group px-md-5 mb-4">
                            <label class="font-bold">{{"GROUP" | translate | titlecase }}</label>
                            <select #scheduleGroupInput (input)="scheduleGroupId = scheduleGroupInput.value"
                                class="form-control custom-select" (change)="getCoursesByGroup()" style="width: 250px;">
                                <option value="">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <option *ngFor="let field of groups" value="{{field.id}}">
                                    {{(globals.lang == 'ar')? field.egroupNameAr :
                                    field.egroupNameEn}} - ({{field.egroupCode}})</option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group px-md-5 mb-4">
                            <label class="font-bold">{{"COURSE" | translate | titlecase }}</label>
                            <select #scheduleCourseInput (input)="scheduleCourseId = scheduleCourseInput.value"
                                class="form-control custom-select" style="width: 250px;">
                                <option value="">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <!-- <option value="1">{{ "TESTING_DATA" | translate | titlecase
                                }}1
                            </option>
                            <option value="2">{{ "TESTING_DATA" | translate | titlecase
                                }}2
                            </option> -->
                                <option *ngFor="let field of coursesByGroup; let i = index" value="{{field.id}}"
                                    [selected]="(i==0)? true : false">
                                    {{(globals.lang == 'ar')? field.subjectNameAr :
                                    field.subjectNameEn}}- ({{field.subjectCode}})</option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group px-md-5 mb-4">
                            <label class="font-bold">{{"PRIMARY_LECTURER" | translate | titlecase }}</label>
                            <select #primaryScheduleLecturerInput
                                (input)="primaryScheduleLecturerId = primaryScheduleLecturerInput.value"
                                class="form-control custom-select" style="width: 250px;">
                                <option value="">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <!-- <option value="1">{{ "TESTING_DATA" | translate | titlecase
                                }}1
                            </option>
                            <option value="2">{{ "TESTING_DATA" | translate | titlecase
                                }}2
                            </option> -->
                                <option *ngFor="let field of primaryLecturers; let i = index" value="{{field.id}}"
                                    [selected]="(i==0)? true : false">
                                    {{(globals.lang == 'ar')? field.teacherNameAr :
                                    field.teacherNameEn}}- ({{field.teacherCode}})</option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group px-md-5 mb-4">
                            <label class="font-bold">{{"SECONDARY_LECTURER" | translate | titlecase }}</label>
                            <select #secondaryScheduleLecturerInput
                                (input)="secondaryScheduleLecturerId = secondaryScheduleLecturerInput.value"
                                class="form-control custom-select" style="width: 250px;">
                                <option value="">{{ "SELECT" | translate | titlecase
                                    }}
                                </option>
                                <!-- <option value="1">{{ "TESTING_DATA" | translate | titlecase
                                }}1
                            </option>
                            <option value="2">{{ "TESTING_DATA" | translate | titlecase
                                }}2
                            </option> -->
                                <option *ngFor="let field of secondaryLecturers; let i = index" value="{{field.id}}"
                                    [selected]="(i==0)? true : false">
                                    {{(globals.lang == 'ar')? field.teacherNameAr :
                                    field.teacherNameEn}}- ({{field.teacherCode}})</option>
                            </select>
                        </div>
                        <br />
                        <a type="button" class="btn btn-primary" style="color: white;" (click)="addScheduleSection()">

                            {{ "ADD" | translate | titlecase }}</a>
                    </div>
                    <div style="text-align: center;font-size: 16px;font-weight: bold;" class="alert-danger"
                        *ngIf="showScheduleTableError">{{ "PLEASE_SELECT_ALL_DATA_ABOVE" | translate | titlecase }}
                    </div>

                    
                <div class="table-responsive py-3">
                    <div style="height: 500px; overflow-y: scroll;">
                        <table  class="table-striped" data-sticky-header="true" id="datatable">
                            <thead style="position: sticky; top: 0; background: white;">
                                 <tr>
                                    <th>{{ "DAY" | translate | titlecase }}</th>
                                    <th>{{ "TYPE" | translate | titlecase }}</th>
                                    <th>{{ "FROM" | translate | titlecase }}</th>
                                    <th>{{ "TO" | translate | titlecase }}</th>
                                    <th>{{ "GROUP" | translate | titlecase }}</th>
                                    <th>{{ "COURSE" | translate | titlecase }}</th>
                                    <th>{{ "PRIMARY_LECTURER" | translate | titlecase }}</th>
                                    <th>{{ "SECONDARY_LECTURER" | translate | titlecase }}</th>
                                    <th class="border-0 font-14 px-2 text-grey"></th>
                                    <th class="border-0 font-14 px-2 text-grey"></th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let res of scheduleParts let i = index">
                                    <td>{{(globals.lang == 'ar')? (res?.schDay | date:'EEEE':'ar-EG-u-nu-latn') :
                                        (res?.schDay | date:'EEEE':'en-US')}}</td>
                                    <td>{{res?.schDayType}}</td>
                                    <td>{{res?.schTimeFrom | date:'HH:mm'}}</td>
                                    <td>{{res?.schTimeTo | date:'HH:mm'}}</td>
                                    <td>{{(res?.group)? (globals.lang == 'ar')? res?.group?.egroupNameAr + " - (" + (res?.group?.egroupCode) + ")" : res?.group?.egroupNameEn + " - (" + res?.group?.egroupCode + ")" : ''}}</td>
                                    <td>{{(globals.lang == 'ar')? res?.course?.subjectNameAr :
                                        res?.course?.subjectNameEn}}</td>
                                    <td>{{(globals.lang == 'ar')? res?.primarylecture?.teacherNameAr :
                                        res?.primarylecture?.teacherNameEn}}</td>
                                    <td>{{(globals.lang == 'ar')? res?.secondarylecture?.teacherNameAr :
                                        res?.secondarylecture?.teacherNameEn}}</td>
                                    <!-- <td>{{res?.primaryTeacherid}}</td> 
                                    <td>{{res?.secondaryTeacherid}}</td> -->
                                    <td class="text-bold text-warning">
                                        <a class="btn btn-sm btn-link text-warning"
                                            (click)="updateCurrentSchedulePartId(res?.id, false)" data-toggle="modal"
                                            data-target="#deleteScheduleModal">
                                            <i class="fas fa-trash"></i>
                                            {{ "REMOVE" | translate | titlecase }}</a>
                                    </td>
                                    <td class="text-bold text-warning">
                                        <a class="btn btn-sm btn-link text-warning"
                                            (click)="updateCurrentSchedulePartId(res?.id, true)" data-toggle="modal"
                                            data-target="#editScheduleSectionModal">
                                            <i class="fas fa-edit"></i>
                                            {{ "EDIT" | translate | titlecase }}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteScheduleModal" tabindex="-1" aria-labelledby="deleteScheduleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <!-- <i class="fas fa-trash text-danger"></i> -->
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div>

                <a type="button" class="btn btn-link text-danger" (click)="removeSchedulePart()" data-dismiss="modal">{{
                    "YES"
                    | translate | titlecase }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>

<!-- update -->
<div class="modal fade" id="editScheduleSectionModal" tabindex="-1" aria-labelledby="editScheduleSectionModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" id="editScheduleSectionModalContainer">

        <form class="modal-content col-md-12" [formGroup]="editSchedulePartForm"
            (submit)="editSchedulePartFormSubmit()">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "EDIT_SCHEDULE_SECTION" | translate | titlecase
                    }}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeEdit>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <app-loader [show]="editingData"></app-loader>
            <div class="modal-body px-md-12" *ngIf="!editingData">
                <div class="row">
                    <div class="col-md-3 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "DAY" | translate | titlecase }}</label>
                        <select class="form-control custom-select" style="width: 150px;"
                            formControlName="editSectionDay">
                            <option value="">{{"SELECT" | translate | titlecase }}
                            </option>
                            <option *ngFor="let field of weekDays" value="{{field.dydate}}">
                                {{field.dy}}</option>
                        </select>
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.editSectionDay.touched && editSchedulePartForm.controls.editSectionDay.invalid && editSchedulePartForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "TYPE" | translate | titlecase }}</label>
                        <select class="form-control custom-select" style="width: 150px;"
                            (change)="onChangeSectionType()" formControlName="editSectionType">
                            <option value="">{{"SELECT" | translate | titlecase }}
                            </option>
                            <option value="LECTURE">{{"LECTURE" | translate | titlecase }}</option>
                            <option value="BREAK">{{"BREAK" | translate | titlecase }}</option>
                        </select>
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.editSectionType.touched && editSchedulePartForm.controls.editSectionType.invalid && editSchedulePartForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "FROM" | translate | titlecase }}</label>
                        <input type="time" class="form-control" formControlName="editTimeFrom">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.editTimeFrom.touched && editSchedulePartForm.controls.editTimeFrom.invalid && editSchedulePartForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "TO" | translate | titlecase }}</label>
                        <input type="time" class="form-control" formControlName="editTimeTo">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.editTimeTo.touched && editSchedulePartForm.controls.editTimeTo.invalid && editSchedulePartForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "GROUP" | translate | titlecase }}</label>
                        <select formControlName="editScheduleGroup" class="form-control custom-select"
                            (change)="getCoursesByGroup(true)" style="width: 250px;">
                            <option value="">{{ "SELECT" | translate | titlecase
                                }}
                            </option>
                            <option *ngFor="let field of groups" value="{{field.id}}">
                                {{(globals.lang == 'ar')? field.egroupNameAr :
                                field.egroupNameEn}} - ({{field.egroupCode}})</option>
                        </select>
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.editScheduleGroup.touched && editSchedulePartForm.controls.editScheduleGroup.invalid && editSchedulePartForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "COURSE" | translate | titlecase }}</label>
                        <select formControlName="editScheduleCourse" class="form-control custom-select"
                            style="width: 250px;">
                            <option value="">{{ "SELECT" | translate | titlecase
                                }}
                            </option>
                            <!-- <option value="1">{{ "TESTING_DATA" | translate | titlecase
                                }}1
                            </option>
                            <option value="2">{{ "TESTING_DATA" | translate | titlecase
                                }}2
                            </option> -->
                            <option *ngFor="let field of editCoursesByGroup; let i = index" value="{{field.id}}">
                                {{(globals.lang == 'ar')? field.subjectNameAr :
                                field.subjectNameEn}}- ({{field.subjectCode}})</option>
                        </select>
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.editScheduleCourse.touched && editSchedulePartForm.controls.editScheduleCourse.invalid && editSchedulePartForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "PRIMARY_LECTURER" | translate | titlecase }}</label>
                        <select formControlName="editPrimaryScheduleLecturer" class="form-control custom-select"
                            style="width: 150px;">
                            <option value="">{{ "SELECT" | translate | titlecase
                                }}
                            </option>
                            <!-- <option value="1">{{ "TESTING_DATA" | translate | titlecase
                                }}1
                            </option>
                            <option value="2">{{ "TESTING_DATA" | translate | titlecase
                                }}2
                            </option> -->
                            <option *ngFor="let field of editPrimaryLecturers; let i = index" value="{{field.id}}">
                                {{(globals.lang == 'ar')? field.teacherNameAr :
                                field.teacherNameEn}}- ({{field.teacherCode}})</option>
                        </select>
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.editPrimaryScheduleLecturer.touched && editSchedulePartForm.controls.editPrimaryScheduleLecturer.invalid && editSchedulePartForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "SECONDARY_LECTURER" | translate | titlecase }}</label>
                        <select formControlName="editSecondaryScheduleLecturer" class="form-control custom-select"
                            style="width: 150px;">
                            <option value="">{{ "SELECT" | translate | titlecase
                                }}
                            </option>
                            <!-- <option value="1">{{ "TESTING_DATA" | translate | titlecase
                                }}1
                            </option>
                            <option value="2">{{ "TESTING_DATA" | translate | titlecase
                                }}2
                            </option> -->
                            <option *ngFor="let field of editSecondaryLecturers; let i = index" value="{{field.id}}">
                                {{(globals.lang == 'ar')? field.teacherNameAr :
                                field.teacherNameEn}}- ({{field.teacherCode}})</option>
                        </select>
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.editSecondaryScheduleLecturer.touched && editSchedulePartForm.controls.editSecondaryScheduleLecturer.invalid && editSchedulePartForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-4">
                        <label class="font-bold">{{"ACTIVE" | translate | titlecase }}</label>
                        <select class="form-control custom-select" formControlName="active">
                            <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                            <option value="YES">{{"YES" | translate | titlecase }}</option>
                            <option value="NO">{{"NO" | translate | titlecase }}</option>
                        </select>
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="editSchedulePartForm.controls.active.touched && editSchedulePartForm.controls.active.invalid && editSchedulePartForm.dirty">
                            {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-schedule-slot-edit" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>